var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.66699C5.40834 1.66699 1.66667 5.40866 1.66667 10.0003C1.66667 14.592 5.40834 18.3337 10 18.3337C14.5917 18.3337 18.3333 14.592 18.3333 10.0003C18.3333 5.40866 14.5917 1.66699 10 1.66699ZM13.9833 8.08366L9.25834 12.8087C9.14167 12.9253 8.98334 12.992 8.81667 12.992C8.65001 12.992 8.49167 12.9253 8.37501 12.8087L6.01667 10.4503C5.77501 10.2087 5.77501 9.80866 6.01667 9.56699C6.25834 9.32533 6.65834 9.32533 6.90001 9.56699L8.81667 11.4837L13.1 7.20033C13.3417 6.95866 13.7417 6.95866 13.9833 7.20033C14.225 7.44199 14.225 7.83366 13.9833 8.08366Z",
    fill: "#21AA47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenConfirm);
export default __webpack_public_path__ + "static/media/green-confirm.2a30a8243b0ddf370e8b420b7bfc94fa.svg";
export { ForwardRef as ReactComponent };